module.exports = __webpack_public_path__ + "static/img/QR3.c18fba1c.jpg";